module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ss-uploader-wrapper",
    class: {
      'hide': !_vm.defaultBtn
    }
  }, [_vm._t("default", [_c('el-button', {
    staticClass: "ssfileupload",
    attrs: {
      "type": _vm.btnType,
      "plain": _vm.btnPlain,
      "size": "large",
      "disabled": _vm.onUploading
    }
  }, [_vm._v("\n      " + _vm._s(_vm.onUploading ? _vm.onUploadingLabel : _vm.label) + "\n    ")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aae0815"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/ss_uploader.input.vue
// module id = 910
// module chunks = 3